const ORCH_BASE_URL = 'https://hmorchestrator.hyperminds.tech';
// const ORCH_BASE_URL = 'http://localhost:8005';


export default ORCH_BASE_URL;